import React, { useState, useEffect ,useRef} from 'react';
import { Button, Table, Form, InputNumber, Spin, Select, Input, Tabs, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, DownloadOutlined, HomeOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const SysParamSegment = (props) => {
    
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [paramSegmentModel, setParamSegmentMdoel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const tableColumns = {
        segment: "segment",
        shortDesc: "short_desc",
        dispSeq: "disp_seq"
    }

    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if(Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("paramSegment/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (value) => {
        messageShowHandler();
        setSearchModel(model =>{
            return {...model,...{segment:value}};
        });
    }
    
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if(key === "2") {
                if(Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if(tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ activeInd: "Y" });
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model,e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchById(model.paramSegmentId)
        setTabIndex("2");
    }

    const searchById = (paramSegmentId,isDelete) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("paramSegment/searchById", paramSegmentId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setParamSegmentMdoel(model)
                if(isDelete){
                    setDeleteTipText(trans.segment[Config.backLang] +":" + model.segment)
                    setIsDeleteFrame(true);
                    return
                }
                setFlag("edit");
                initForm(model)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            segment: model.segment ?? '',
            shortDesc: model.shortDesc ?? '',
            longDesc: model.longDesc ?? '',
            parmValue1: model.parmValue1 ?? '',
            parmValue2: model.parmValue2 ?? '',
            parmValue3: model.parmValue3 ?? '',
            parmValue4: model.parmValue4 ?? '',
            parmValue5: model.parmValue5 ?? '',
            parmValue6: model.parmValue6 ?? '',
            activeInd: model.activeInd ?? '',
            dispSeq: model.dispSeq ?? '',
        });
    }

    const deleteOne = (model,e) => {
        e.stopPropagation();
        setParamSegmentMdoel(model)
        searchById(model.paramSegmentId ,true)
    }

    const deleteFrameClose = (state) => {
        if(state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = paramSegmentModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("paramSegment/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model ,e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        fetch(Config.apiDownloadServer + "paramSegment/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, trans.downloadParam[Config.backLang]);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = trans.downloadParam[Config.backLang];
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if(flag === "add") {
            url = "paramSegment/insert";
        } else {
            url = "paramSegment/update"
            values.paramSegmentId = paramSegmentModel.paramSegmentId;
            values.lastUpdatedDate = paramSegmentModel.lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }


    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if(state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const columns = [
        {
            title: trans.segment[Config.backLang],
            dataIndex: 'segment',
            className: 'tableWidth13',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'segment') },
        },
        {
            title: trans.segmentName[Config.backLang],
            dataIndex: 'shortDesc',
            className: 'tableWidth13',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'shortDesc') },
        },
        {
            title: trans.longDesc[Config.backLang],
            dataIndex: 'longDesc',
            className: 'tableWidth17',
            ellipsis: true
        },
        {
            title: trans.parmValue1[Config.backLang],
            dataIndex: 'parmValue1',
            className: 'tableWidth12',
            ellipsis: true
        },
        {
            title: trans.parmValue2[Config.backLang],
            dataIndex: 'parmValue2',
            className: 'tableWidth10',
            ellipsis: true
        },
        {
            title: trans.parmValue3[Config.backLang],
            dataIndex: 'parmValue3',
            className: 'tableWidth10',
            ellipsis: true
        },
        {
            title: trans.parmValue4[Config.backLang],
            dataIndex: 'parmValue4',
            className: 'tableWidth10',
            ellipsis: true
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValueTransalation('indsTransalation', text)
        },
        {
            title: trans.dispSeq[Config.backLang],
            dataIndex: 'dispSeq',
            className: 'tableWidth6 tableRightAlignment',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'dispSeq') },
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed:'right',
            width: 208,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record ,e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record,e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record,e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    return(
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText}/> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane tab={trans.list[Config.backLang]} key="1">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.segment[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.segment[Config.backLang]} maxLength={20} value={searchModel.segment}
                                            onChange={(e) => searchChange(e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                {tables.length == 0 ? null :
                                    <>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>{trans.downloadExcel[Config.backLang]}</Button>
                                    </>
                                }
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowKey="paramSegmentId"
                                    scroll={{ x: 1400 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size:"small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={trans.segmentNameTitle[Config.backLang]} key="2" forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.segment[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="segment"
                                                rules={[
                                                    { required: true, message: trans.segmentNoIsNull[Config.backLang] },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 30)}
                                            >
                                                <Input type="text" placeholder={trans.segment[Config.backLang]} maxLength={30} disabled={flag === 'edit'}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.segmentName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="shortDesc"
                                                rules={[
                                                    { required: true, message: trans.segmentNameNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.segmentName[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">{trans.longDesc[Config.backLang]}</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="longDesc"
                                            >
                                                <TextArea placeholder={trans.longDesc[Config.backLang]} maxLength={250} rows={3}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.parmValue1[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="parmValue1"
                                            >
                                                <Input type="text" placeholder={trans.parmValue1[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.parmValue2[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="parmValue2"
                                            >
                                                <Input type="text" placeholder={trans.parmValue2[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.parmValue3[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="parmValue3"
                                            >
                                                <Input type="text" placeholder={trans.parmValue3[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.parmValue4[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="parmValue4"
                                            >
                                                <Input type="text" placeholder={trans.parmValue4[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.parmValue5[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="parmValue5"
                                            >
                                                <Input type="text" placeholder={trans.parmValue5[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.parmValue6[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="parmValue6"
                                            >
                                                <Input type="text" placeholder={trans.parmValue6[Config.backLang]} maxLength={100}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select placeholder={trans.activeInd[Config.backLang]} className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {context.indsTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.dispSeq[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="dispSeq"
                                                rules={[
                                                    { required: true, validator: (rule, value) => Base.checkNbrOrNull(value, null, 999999999) },
                                                ]}
                                            >
                                                <InputNumber className='sysInputNumber' placeholder={trans.dispSeq[Config.backLang]} precision={0} maxLength={9}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default SysParamSegment;